import { render, staticRenderFns } from "./HomeBanner.vue?vue&type=template&id=37e425a6&"
import script from "./HomeBanner.vue?vue&type=script&lang=ts&"
export * from "./HomeBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports